import { z } from 'zod'

export const RegistryToken = z.object({
  id: z.number(),
  name: z.string(),
  active: z.boolean(),
  scopes: z.array(z.string()).nullable().optional(),
  pull_only: z.boolean().optional(),
  created_at: z.string(),
  last_used: z.string().nullable().optional(),
  expires_at: z.string().nullable().optional()
})
export type RegistryToken = z.infer<typeof RegistryToken>

export const RegistryTokenCreateRequest = z.object({
  name: z.string().min(1),
  scopes: z.array(z.string()).optional(),
  expires_at: z.string().optional(),
  pull_only: z.boolean().optional()
})
export type RegistryTokenCreateRequest = z.infer<typeof RegistryTokenCreateRequest>

export const RegistryTokenCreateResponse = z.object({
  token: z.string(),
  id: z.number(),
  name: z.string()
})
export type RegistryTokenCreateResponse = z.infer<typeof RegistryTokenCreateResponse>
